import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private readonly _loader = signal(false);
  private readonly _mainLoader = signal(false);
  private readonly _loaderMessage = signal('Please wait while we update the data.');

  readonly loader = this._loader.asReadonly();
  readonly mainLoader = this._mainLoader.asReadonly();
  readonly loaderMessage = this._loaderMessage.asReadonly();

  loaderOn(): void {
    this._loader.set(true);
  }

  loaderOff(): void {
    this._loader.set(false);
  }

  mainLoaderOn(): void {
    this._mainLoader.set(true);
  }

  mainLoaderOff(): void {
    this._mainLoader.set(false);
  }

  setLoaderMessage(message: string): void {
    this._loaderMessage.set(message);
  }
}
